module.exports = __webpack_public_path__ + "img/home-nav-icon-1.f3968584.png";